<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-08 09:54:49
 * @LastEditors: xgx
 * @LastEditTime: 2023-06-01 12:17:36
-->
<template>
  <div>
    <div class="top">
      <el-button  v-if="codeData.indexOf('81') != -1" @click="addAdminFnOpen" type="primary"
        >添加栏目</el-button
      >
      <div class="search">
       <a-input style="width:170px;margin-right:20px" v-model:value="value" placeholder="栏目名称" />
        <el-button @click="search" type="primary">查询</el-button>
      </div>
    </div>
    <a-spin :spinning="loading">
          <multistageTable  @isLoading="isLoading" ref="tableColumn"  @addAdminFn="addAdminFn" @editAdmin="editAdmin"/>
    </a-spin>
    <AddColumn @parentIdFn="parentIdFn" @onClose="onClose" :columnId="columnId" :visible="visibleTwo" :itemId="itemId"/>
  </div>
</template>

<script>
import multistageTable from './multistage_table.vue';
import AddColumn from './add_column.vue';
export default {
  data() {
    return {
      height: 0,
      visible:false,
      resData:[],
      value:'',
      loading:false,
      codeData:[],
      visibleTwo:false,
      itemId:'',
      columnId:null,
      oldData:[],
      flag:1,
      itemData:{},
      btnOpen:false,
      parentIdData:0,
    };
  },
  components: {
    multistageTable,
    AddColumn
  },
  mounted() {
    this.height = document.documentElement.clientHeight - 419;
    this.codeData = JSON.parse(sessionStorage.getItem('menuData'))
  },
  methods: {
    parentIdFn(parId){
        this.parentIdData = parId;
        console.log(this.parentIdData,'ssssssssss')
    },
    search(){
       this.$nextTick(()=>{
          this.$refs.tableColumn.getList(this.value)
          this.$refs.tableColumn.searchRefreshData()
       })
       if(!this.value){
          this.$refs.tableColumn.getList(this.value)
       }
    },
    isLoading(item){
        this.loading = item;
    },
    onClose(value){
          this.visibleTwo = false;
          if(value && this.btnOpen){
               this.$refs.tableColumn.refreshData(value)
          }
          this.$nextTick(()=>{
              if(this.value){
                if(this.columnId){
                  this.$refs.tableColumn.refreshData(this.itemData.id)
                }else{
                  this.$refs.tableColumn.getList(this.value)
                  this.$refs.tableColumn.refreshData(this.itemData.parentId)
                }
              }else{
                this.$refs.tableColumn.refreshData(this.itemData.parentId)
                this.$refs.tableColumn.refreshData(this.itemData.id)
              }
               this.$refs.tableColumn.refreshData(this.parentIdData)
          })
           this.btnOpen = false;
    },
    addAdminFn(item={}){
      this.visibleTwo = true;
      this.itemId = '';
      this.columnId = item.id;
      this.itemData = item;
    },
    addAdminFnOpen(){
      this.visibleTwo = true;
      this.itemId = '';
      this.btnOpen = true;
       this.columnId = undefined;
    },
    close(){
        this.visible = false;
    },
    editAdmin(item){
      this.visibleTwo = true;
      this.itemId = item.id;
      this.columnId = null;
      this.itemData = item;
    },
    open() {
        this.$prompt('站点删除是不可逆的操作，若确需删除，请在下方输入框中输入站点名称后在点击"确认删除"按钮', '确认删除站点', {
          confirmButtonText: '确认删除',
          cancelButtonText: '取消',
          inputPlaceholder:"请输入确需删除的站点名称",
          customClass:'deletBox',
          dangerouslyUseHTMLString:true
        }).then(({ value }) => {
          console.log(value,'sssssssssss');
        }).catch(() => {

        });
      }
    }
};
</script>

<style lang="less" scoped>
.top {
  width: 100%;
  padding: 24px;
  padding-bottom: 0px;
  display: flex;
  justify-content: space-between;
  .search {
            display: flex;
            /deep/ .ant-select-selection {
                background-color: rgba(245, 247, 250, 1);
                height: 40px;
            }
            /deep/ .ant-input {
                background-color: rgba(245, 247, 250, 1);
                height: 40px;
            }
            /deep/ .el-select .el-input__inner {
                background-color: rgba(245, 247, 250, 1);
            }
            /deep/ input::-webkit-input-placeholder {
                color: rgba(102, 111, 128, 1);
            }
            /deep/ .ant-select-selection__placeholder {
                color: rgba(102, 111, 128, 1);
            }
            /deep/ .ant-select-selection__rendered {
                line-height: 39px;
            }
            /deep/ input::-webkit-input-placeholder {
            color: #415058;
            }
            /deep/ .ant-select-selection__placeholder {
                color: #415058;
            }
        }
  .add-img {
    margin-top: -2px;
    margin-right: 3px;
  }
}
.el-button--primary {
  background: #176de6;
}
.deletBox{
    background: red !important;
   .el-message-box__message{
    color:#ccc !important;
   }
}
</style>